/**
 * Data dispatch report IDs.
 */
export enum DataDispatchReport {
	RENTAL_AGREEMENT_EMAIL_CUSTOMER_CONFIRMATION = 'rental_agreement_email_customer_confirmation',
	RENTAL_AGREEMENT_PRINT_AGREEMENT = 'rental_agreement_print_agreement',
	RENTAL_RESERVATION_EMAIL_CUSTOMER_REQUEST_CONFIRMATION = 'rental_reservation_email_customer_request_confirmation',
	RENTAL_RESERVATION_EMAIL_CUSTOMER_ACCEPTED_REQUEST_CONFIRMATION = 'rental_reservation_email_customer_accepted_request_confirmation',
	RENTAL_RESERVATION_EMAIL_CUSTOMER_REJECTED_REQUEST_CONFIRMATION = 'rental_reservation_email_customer_rejected_request_confirmation',
	PAYMENTS_EMAIL_PAYMENT_REQUEST = 'payments_email_payment_request',
}
